import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { InterviewProblemSolving } from './interview-problem-solving';
export { InterviewProblemSolving };
import { interviewProblemSolvingSchema } from '@schemas/business-objects/interview-problem-solving';
import { InterviewFormGroup } from './interview-form-group';

export class InterviewProblemSolvingFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    problemSolvingScore: SchemaFormControl;
    notes: SchemaFormControl;
    interviewId: SchemaFormControl;
    interview: InterviewFormGroup;
  };

  declare value: Partial<InterviewProblemSolving>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(
      interviewProblemSolvingSchema,
      InterviewProblemSolving,
      data,
      options,
    );
  }

  get object(): InterviewProblemSolving {
    return new InterviewProblemSolving(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'interview':
        return new InterviewFormGroup();
      default:
        return undefined;
    }
  }
}

export class InterviewProblemSolvingFormArray extends PersistedFormArray {
  readonly entityName = 'InterviewProblemSolving' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(interviewProblemSolvingSchema, InterviewProblemSolving, options);
  }

  protected override createItemGroup() {
    return new InterviewProblemSolvingFormGroup();
  }

  get array(): InterviewProblemSolving[] {
    return this.controls.map(
      (group: InterviewProblemSolvingFormGroup) => group.object,
    );
  }
}

export class InterviewProblemSolvingPersistedArray extends PersistedArray<InterviewProblemSolving> {
  readonly entityName = 'InterviewProblemSolving' as const;

  constructor(options?: PersistedArrayOptions) {
    super(InterviewProblemSolving, options);
  }
}
